export default [
  {
    'text': '경로 변경',
    'state': 'CHANGE_ROUTE'
  },
  {
    'text': '만취',
    'state': 'DRUNKEN'
  },
  {
    'text': '미도착',
    'state': 'NO_SHOW'
  },
  {
    'text': '일행 동반',
    'state': 'WITH_SOMEONE'
  },
  {
    'text': '큰 짐',
    'state': 'BIG_LOAD'
  },
  {
    'text': '단순 변심',
    'state': 'CHANGE_HEART'
  },
  {
    'text': '먼 거리',
    'state': 'FAR_AWAY'
  },
];



// WEBPACK FOOTER //
// ./src/api/blameType.js